import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ConfigData, ConfigTheme } from "../types/core";

interface ConfigState {
  data: ConfigData;
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

export const isValidTheme = (theme: unknown): theme is ConfigTheme => {
  return typeof theme === "string" && ["light", "dark", "auto"].includes(theme);
};

const initialState: ConfigState = {
  data: {
    frameId: "",
    apiBase: "",
    cookieDomain: "",
    sessionRefreshLifetime: 0,
    theme: "auto",
    locale: "",
    mode: "launcher",
    selector: "",
    whatsappId: "",
    previewDelayMs: 3000,
  },
  status: "idle",
  error: null,
};

const configSlice = createSlice({
  name: "config",
  initialState,
  reducers: {
    setConfig: (state, action) => {
      state.data = action.payload;
      state.status = "succeeded";
    },
    setTheme: (state, action: PayloadAction<ConfigTheme>) => {
      if (!isValidTheme(action.payload)) {
        state.error = `Invalid theme: ${action.payload}`;
        return;
      }
      state.data.theme = action.payload;
    },
    refreshTheme: (state) => {},
    setLocale: (state, action: PayloadAction<string>) => {
      state.data.locale = action.payload;
    },
    setMode: (state, action: PayloadAction<ConfigData["mode"]>) => {
      state.data.mode = action.payload;
    },
  },
});

export const { setConfig, setLocale, setMode, setTheme, refreshTheme } =
  configSlice.actions;
export const configReducer = configSlice.reducer;
